const BUSINESS_CATEGORY = {
  SELF_EMPLOYEE: '個人事業主',
  SMALL_COMPANY: '中小企業',
  BIG_COMPANY: '大企業',
}

const BUSINESS_CARD_LABEL_NAME = 'business' //card-filteringで検索に使われる条件値の名称

const BUSINESS_CARD_FILTER_NAME = 'ビジネスカード'

module.exports = { BUSINESS_CATEGORY, BUSINESS_CARD_LABEL_NAME, BUSINESS_CARD_FILTER_NAME }
